/* Nuralis Hair & Scalp Serum (hs1012) — document-scoped, config-driven, Ascendify cart-drawer wired.
   Rewritten from the R4 preview pdp.js. Boots once on DOMContentLoaded. */
(() => {
  'use strict';
  if (window.__HS1012_BOOTED__) return;
  window.__HS1012_BOOTED__ = true;

  const boot = () => {
    const $  = (s, r = document) => r.querySelector(s);
    const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const params = new URLSearchParams(location.search);
    const him = params.get('for') === 'him';

    /* ---- male creative variant copy swap ---- */
    if (him) $$('[data-him]').forEach(e => { e.innerHTML = e.dataset.him; });

    /* ---- config (emitted by hero/offer from the Liquid resolver) ---- */
    const CFG = window.HS1012_CONFIG || { packs: {} };
    const packs = CFG.packs || {};
    const money = c => {
      const n = (Number(c) || 0) / 100;
      return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    const packIds = Object.keys(packs).map(Number).sort((a, b) => a - b);
    const firstPack = packIds[0] || 1;
    // SOP 0l — reflect the chosen pack's variant in the URL (?variant=<id>), native-PDP style.
    const updateVariantUrl = id => { if (!id) return; try { const u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState({}, '', u); } catch (e) {} };

    /* ---- pack selection sync (hero + offer + sticky) ---- */
    let selected = firstPack;
    const stickyName  = $('[data-sticky-name]');
    const stickyPrice = $('[data-sticky-price]');
    function sync(n) {
      selected = Number(n);
      const p = packs[selected] || {};
      $$('.tier input').forEach(r => {
        const on = Number(r.value) === selected;
        r.checked = on;
        const tier = r.closest('.tier');
        if (tier) tier.classList.toggle('selected', on);
      });
      const total = p.total_cents != null ? money(p.total_cents) : '';
      $$('[data-total]').forEach(e => {
        e.textContent = total + (e.closest('.selected-summary') ? ' total' : '');
      });
      const bottles = selected + ' ' + (selected === 1 ? 'bottle' : 'bottles');
      $$('[data-contents]').forEach(e => { e.textContent = bottles + ' · ' + (p.ml || '') + ' ml'; });
      if (stickyName)  stickyName.textContent  = (CFG.name || 'Nuralis GHK-Cu') + ' · ' + bottles;
      if (stickyPrice) stickyPrice.textContent = total + ' total · ' + (p.ml || '') + ' ml';
      // keep the live variant id on every buy form
      $$('[data-variant-id]').forEach(i => { if (p.id) i.value = p.id; });
    }
    $$('.tier input').forEach(r => r.addEventListener('change', () => { sync(r.value); updateVariantUrl((packs[Number(r.value)] || {}).id); }));
    // SOP 0l — preselect the pack whose variant matches an existing ?variant= (no URL rewrite on load).
    let startPack = firstPack;
    const _qv = params.get('variant');
    if (_qv) { for (let k = 0; k < packIds.length; k++) { if (String((packs[packIds[k]] || {}).id) === String(_qv)) { startPack = packIds[k]; break; } } }
    if (packIds.length) sync(startPack);

    /* ---- gallery (frames from HS1012_FRAMES; him overrides slide 0) ---- */
    const frames = (window.HS1012_FRAMES || []).slice();
    if (him && window.HS1012_FRAME_HIM) frames[0] = window.HS1012_FRAME_HIM;
    const gallery = $('#gallery-image');
    let slide = 0;
    function show(i) {
      if (!gallery || !frames.length) return;
      slide = (i + frames.length) % frames.length;
      gallery.src = frames[slide][0];
      gallery.alt = frames[slide][1] || '';
      $$('[data-slide]').forEach(b => b.setAttribute('aria-pressed', Number(b.dataset.slide) === slide));
    }
    if (gallery && frames.length) {
      if (him && frames[0]) { const t = $('[data-slide="0"] img'); if (t) t.src = frames[0][0]; }
      $$('[data-slide]').forEach(b => b.addEventListener('click', () => show(+b.dataset.slide)));
      $$('[data-step]').forEach(b => b.addEventListener('click', () => show(slide + (+b.dataset.step))));
      const stage = $('.gallery-stage');
      if (stage) stage.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); show(slide + (e.key === 'ArrowRight' ? 1 : -1)); }
      });
      let tx = 0;
      gallery.addEventListener('touchstart', e => tx = e.changedTouches[0].clientX, { passive: true });
      gallery.addEventListener('touchend', e => {
        const dx = e.changedTouches[0].clientX - tx;
        if (Math.abs(dx) > 50) show(slide + (dx < 0 ? 1 : -1));
      }, { passive: true });
      show(0);
    }

    /* ---- zoom + dialogs ---- */
    const zoomBtn = $('[data-zoom]');
    if (zoomBtn && gallery) zoomBtn.addEventListener('click', () => {
      const d = $('.zoom-dialog'); if (!d) return;
      const img = d.querySelector('img'); img.src = gallery.src; img.alt = gallery.alt; d.showModal();
    });
    $$('dialog').forEach(d => {
      const c = d.querySelector('.dialog-close'); if (c) c.addEventListener('click', () => d.close());
      d.addEventListener('click', e => {
        if (e.target === d) {
          const r = d.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
        }
      });
    });

    /* ---- Ascendify cart-drawer bridge (ported from the working LymphFlow build) ---- */
    const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const setCount = n => $$('[data-np-cart-count]').forEach(el => { el.textContent = n; el.hidden = !(Number(n) > 0); });
    const openDrawer = () => { const d = document.querySelector('cart-drawer'); if (d) { if (typeof d.open === 'function') d.open(); else d.classList.add('active','is-open','open'); return true; } return false; };
    const syncCount = async () => { try { const c = await (await fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })).json(); setCount(c.item_count); } catch (e) {} };
    ['cart:updated','cart:refresh','cart:change'].forEach(ev => document.addEventListener(ev, syncCount));
    const bub = document.getElementById('cart-icon-bubble') || document.querySelector('.cart-count-bubble,[data-cart-count]');
    if (bub) new MutationObserver(syncCount).observe(bub, { childList: true, subtree: true, characterData: true });
    document.addEventListener('click', e => { const bag = e.target.closest('[data-np-cart]'); if (bag) { if (openDrawer()) e.preventDefault(); } });

    const swapDrawer = (dest, html) => { if (!dest || !html) return; const doc = new DOMParser().parseFromString(html, 'text/html'); const fresh = doc.querySelector('cart-drawer') || doc.getElementById('shopify-section-cart-drawer') || doc.querySelector('.shopify-section') || doc.body; if (!fresh) return; const inner = fresh.innerHTML; if (!inner || !inner.trim()) return; if (fresh.tagName && fresh.tagName.toLowerCase() === 'cart-drawer') { [...fresh.attributes].forEach(a => { try { dest.setAttribute(a.name, a.value); } catch (e) {} }); } else dest.classList.remove('is-empty','empty'); dest.innerHTML = inner; };
    const swapBubble = html => { const dest = document.getElementById('cart-icon-bubble'); if (!dest || !html) return; const doc = new DOMParser().parseFromString(html, 'text/html'); const fresh = doc.getElementById('cart-icon-bubble') || doc.querySelector('.shopify-section') || doc.body; const inner = fresh ? fresh.innerHTML : ''; if (inner && inner.trim()) dest.innerHTML = inner; };
    const drawerAdd = async (id, plan) => {
      const drawer = document.querySelector('cart-drawer');
      if (!id || !drawer) return false;
      const item = { id: Number(id), quantity: 1 };
      if (plan) item.selling_plan = Number(plan);
      const add = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) });
      if (!add.ok) throw new Error(((await add.json().catch(() => ({}))).description) || 'This pack could not be added.');
      try { const r = await fetch(ROOT + '?sections=cart-drawer,cart-icon-bubble'); const data = await r.json(); swapDrawer(drawer, data['cart-drawer']); swapBubble(data['cart-icon-bubble']); } catch (e) {}
      syncCount(); openDrawer(); return true;
    };

    let busy = false;
    const submitAdd = async (form) => {
      if (busy) return;
      const p = packs[selected] || {};
      const id = p.id;
      busy = true;
      const btns = $$('.purchase');
      btns.forEach(b => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      const done = () => { busy = false; btns.forEach(b => { b.disabled = false; b.removeAttribute('aria-busy'); }); };
      try {
        if (!id) { done(); if (form) form.submit(); return; }                 // config missing -> native form add
        const added = await drawerAdd(id, p.selling_plan);
        if (!added) {                                                          // theme has no <cart-drawer> -> native add + cart page
          const item = { id: Number(id), quantity: 1 }; if (p.selling_plan) item.selling_plan = Number(p.selling_plan);
          const r = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) });
          if (!r.ok) { done(); if (form) form.submit(); return; }
          location.assign(ROOT + 'cart'); return;
        }
        done();
      } catch (err) { done(); }                                               // stock/other error -> re-enable, let the user retry
    };
    $$('form.hs1012-buy-form').forEach(form => form.addEventListener('submit', e => { e.preventDefault(); submitAdd(form); }));
    syncCount();

    /* ---- sticky bar: fallback CTA, hidden whenever a buy CTA is on screen ---- */
    const sticky = $('.sticky');
    if (sticky) {
      const ctas = $$('.purchase, [data-chooser]').filter(b => !sticky.contains(b));
      const vis = new Set();
      const io = new IntersectionObserver(es => {
        es.forEach(en => { if (en.isIntersecting) vis.add(en.target); else vis.delete(en.target); });
        const hero = $('#product');
        const aboveFold = hero ? hero.getBoundingClientRect().bottom > 0 : true;
        sticky.hidden = !packIds.length || aboveFold || vis.size > 0;
      }, { threshold: 0 });
      ctas.forEach(c => io.observe(c));
      const hero = $('#product'); if (hero) io.observe(hero);
      const chooser = $('[data-chooser]');
      if (chooser) chooser.addEventListener('click', () => {
        const closing = $('[data-buybox="closing"]') || $('#offer');
        if (closing) {
          closing.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'center' });
          const inp = closing.querySelector('input:checked'); if (inp) inp.focus({ preventScroll: true });
        }
      });
    }

    /* ---- mirror concern selector ---- */
    const mresp = $('.mirror-response');
    $$('.mirror-checks input').forEach(i => i.addEventListener('change', () => {
      if (!mresp) return;
      const n = $$('.mirror-checks input:checked').length;
      mresp.textContent = n === 0
        ? (mresp.dataset.r0 || 'Select what you recognise. You do not have to explain why this matters to you.')
        : n === 1
          ? (mresp.dataset.r1 || 'That small change can stay on your mind. Wanting to care for it is understandable.')
          : (mresp.dataset.r2 || 'You recognise [n] of these concerns. You deserve clear information and a routine that respects your day.').replace('[n]', n);
    }));

    /* ---- comparison competitor switch (mobile) ---- */
    $$('[data-compare]').forEach(b => b.addEventListener('click', () => {
      $$('[data-compare]').forEach(x => x.setAttribute('aria-pressed', x === b));
      $$('[data-col]').forEach(x => x.classList.toggle('mobile-active', x.dataset.col === b.dataset.compare));
    }));

    /* ---- science: pinned 3-chapter scroll with per-chapter footage ---- */
    const chapters = window.HS1012_CHAPTERS || [];
    const v = $('#science-video'), story = $('#science'), stage = story ? story.querySelector('.science-stage') : null;
    if (v && story && stage && chapters.length) {
      let chapter = -1, paused = reduced.matches, inView = false, scrollFrame = 0;
      const pauseBtn = $('#film-pause');
      function updatePause() {
        if (!pauseBtn) return;
        pauseBtn.textContent = paused ? 'Play ▶' : 'Pause ⏸';
        pauseBtn.setAttribute('aria-label', paused ? 'Play science film' : 'Pause science film');
      }
      async function changeChapter(n) {
        if (n === chapter) return;
        chapter = n; const c = chapters[n]; if (!c) return;
        const k = $('#chapter-kicker'), t = $('#chapter-title'), b = $('#chapter-body');
        if (k) k.textContent = c.k; if (t) t.textContent = c.h; if (b) b.textContent = c.p;
        $$('[data-chapter]').forEach(x => x.setAttribute('aria-pressed', Number(x.dataset.chapter) === n));
        if (c.poster) v.poster = c.poster;
        if (c.video) { v.src = c.video; v.load(); }
        if (!paused && inView) await v.play().catch(err => { if (err && err.name === 'NotAllowedError') { paused = true; updatePause(); } });
        updatePause();
      }
      function scrollStory() {
        scrollFrame = 0;
        const rect = story.getBoundingClientRect();
        const distance = Math.max(1, story.offsetHeight - stage.offsetHeight);
        const progress = Math.max(0, Math.min(1, -rect.top / distance));
        const n = Math.min(chapters.length - 1, Math.floor(progress * chapters.length));
        changeChapter(n);
        $$('[data-chapter] span').forEach((bar, i) => {
          const pct = i < n ? 100 : i > n ? 0 : Math.min(100, (progress * chapters.length - n) * 100);
          bar.style.setProperty('--chapter-progress', pct + '%');
        });
      }
      function requestStory() { if (!scrollFrame) scrollFrame = requestAnimationFrame(scrollStory); }
      window.addEventListener('scroll', requestStory, { passive: true });
      window.addEventListener('resize', requestStory);
      $$('[data-chapter]').forEach(b => b.addEventListener('click', () => {
        const n = Number(b.dataset.chapter);
        const distance = story.offsetHeight - stage.offsetHeight;
        window.scrollTo({ top: window.scrollY + story.getBoundingClientRect().top + distance * (n / chapters.length + 0.02), behavior: reduced.matches ? 'auto' : 'smooth' });
      }));
      v.loop = true;
      if (pauseBtn) pauseBtn.addEventListener('click', () => {
        paused = !paused;
        if (paused) v.pause(); else v.play().catch(() => { paused = true; updatePause(); });
        updatePause();
      });
      new IntersectionObserver(es => { inView = es[0].isIntersecting; if (inView && !paused) v.play().catch(() => {}); else v.pause(); }, { threshold: 0.15 }).observe(stage);
      reduced.addEventListener('change', () => { if (reduced.matches) { paused = true; v.pause(); updatePause(); } });
      document.addEventListener('visibilitychange', () => { if (document.hidden) v.pause(); else if (inView && !paused) v.play().catch(() => {}); });
      updatePause();
      requestStory();
    }

    /* ---- usage application film ---- */
    const usageVideo = $('.usage-film'), usagePause = $('.usage-pause');
    if (usageVideo) {
      let usagePaused = reduced.matches, usageInView = false;
      function updateUsage() {
        if (!usagePause) return;
        usagePause.textContent = usagePaused ? 'Play ▶' : 'Pause ⏸';
        usagePause.setAttribute('aria-label', usagePaused ? 'Play application film' : 'Pause application film');
      }
      if (reduced.matches) usageVideo.removeAttribute('autoplay');
      new IntersectionObserver(es => { usageInView = es[0].isIntersecting; if (usageInView && !usagePaused) usageVideo.play().catch(() => {}); else usageVideo.pause(); }, { threshold: 0.25 }).observe(usageVideo);
      if (usagePause) usagePause.addEventListener('click', () => {
        usagePaused = !usagePaused;
        if (usagePaused) usageVideo.pause(); else usageVideo.play().catch(() => { usagePaused = true; updateUsage(); });
        updateUsage();
      });
      reduced.addEventListener('change', () => { if (reduced.matches) { usagePaused = true; usageVideo.pause(); updateUsage(); } });
      document.addEventListener('visibilitychange', () => { if (document.hidden) usageVideo.pause(); else if (usageInView && !usagePaused) usageVideo.play().catch(() => {}); });
      updateUsage();
    }

    /* ---- metric count-ups ---- */
    const counterObserver = new IntersectionObserver(entries => entries.forEach(e => {
      if (!e.isIntersecting) return;
      const el = e.target, to = +el.dataset.count, duration = +el.dataset.duration || 1200;
      const fmt = n => el.dataset.money ? '$' + n.toFixed(2) : Math.round(n).toLocaleString('en-US');
      counterObserver.unobserve(el);
      if (reduced.matches) { el.textContent = fmt(to); return; }
      const start = performance.now();
      (function tick(now) {
        const p = Math.min((now - start) / duration, 1);
        el.textContent = fmt(to * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(tick);
      })(start);
    }), { threshold: 0.6 });
    $$('[data-count]').forEach(e => counterObserver.observe(e));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
